import { useMemo, useRef, useState } from "react";
import { PublicPageHeader } from "../../../components/headers/header-public-page/header-public-page";
import { Navbar } from "../../../components/nav";
import { MotoboyList, MotoboyRef } from "./components/motoboy-list";
import { useStyles } from "./motoboy-styles";
import { CircularProgress, Tooltip } from "@material-ui/core";
import { RotaIcon } from "../../../components/icons";
import { ButtonNavbar } from "../../../components/buttons/button-navbar/button-navbar";

const MotoboyPage = () => {
    const classes = useStyles();

    const [carregandoLocalizacao, setCarregandoLocalizacao] = useState<boolean>(false)
    const refMotoboyList = useRef<MotoboyRef>(null);

    const rightArea = useMemo(() => {
        return (
            <Tooltip title="Otimizar Rota">
                <ButtonNavbar onClick={() => refMotoboyList.current?.tracarRotas()}>
                    {carregandoLocalizacao ? <CircularProgress classes={{
                        circle: classes.loading
                    }} color="inherit" size={24} /> : (
                        <RotaIcon style={{ margin: 0 }} tipo="BUTTON_PRIMARY" />
                    )}
                </ButtonNavbar>
            </Tooltip>
        )
    }, [carregandoLocalizacao, classes.loading])

    return (
        <>
            <PublicPageHeader topOpacity="0.8" />
            <div className={classes.divRoot}>
                <Navbar titulo={'Entregas Pendentes'} rightArea={rightArea} />
                <div className={classes.root}>
                    <MotoboyList ref={refMotoboyList} setCarregandoLocalizacao={setCarregandoLocalizacao} />
                </div>
            </div>
        </>
    )
}

export default MotoboyPage;